var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 71,
    height: 35,
    viewBox: "0 0 71 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9055 34.0652H0V0.523926H12.7745C16.2247 0.523926 19.2054 1.19541 21.7167 2.53837C24.2388 3.87041 26.1823 5.79205 27.5471 8.30328C28.9228 10.8036 29.6107 13.8007 29.6107 17.2946C29.6107 20.7884 28.9283 23.791 27.5635 26.3022C26.1987 28.8025 24.2661 30.7242 21.7658 32.0671C19.2655 33.3992 16.3121 34.0652 12.9055 34.0652ZM9.10593 26.335H12.578C14.2376 26.335 15.6515 26.0675 16.8198 25.5325C17.999 24.9975 18.8943 24.0749 19.5057 22.7647C20.128 21.4545 20.4392 19.6311 20.4392 17.2946C20.4392 14.958 20.1226 13.1347 19.4893 11.8245C18.867 10.5142 17.9498 9.59164 16.7379 9.05664C15.5369 8.52164 14.0629 8.25414 12.3159 8.25414H9.10593V26.335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0695 0H58.4351V8.34918H33.0695V0Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0695 13.1201H58.4351V21.4693H33.0695V13.1201Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0695 26.2403H58.4351V34.5894H33.0695V26.2403Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M71 0.523926V34.0652H61.894V0.523926H71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDei);
export default __webpack_public_path__ + "static/media/DEI.7093f20ad279a4a64359d938d5646bbc.svg";
export { ForwardRef as ReactComponent };